import { Icon } from '@iconify/react'
import { Button } from '@pepper/ui'

import OrdersEmpty from 'assets/images/content-ideas/orders-empty.png'

import s from './EmptyState.module.css'

type Props = {
  onOrderContent: () => void
}

export const EmptyState = ({ onOrderContent }: Props) => {
  return (
    <div className={s.wrapper}>
      <img src={OrdersEmpty} alt="orders-empty" />
      <div className={s.header}>Your ordered content appear here..</div>
      <div className={s.subHeader}>
        Every great content journey begins with a single word. Let’s get
        started! 👇
      </div>
      <Button
        onClick={onOrderContent}
        size="middle"
        type="primary"
        icon={<Icon icon="memory:plus" width={16} height={16} />}
        iconPlacement="left"
      >
        Order content from Experts
      </Button>
    </div>
  )
}
